import styled from '@emotion/styled';
import { Css, FixedGridItem, Responsive } from '@/ui';
import {
	FooterSocialLinks,
	IFooterSocialLinksProps,
} from './FooterSocialLinks';
import { DigicertSiteSeal } from '../digicert/DigicertSiteSeal';

interface IFooterSocialsSection {
	socialLinks: IFooterSocialLinksProps;
}

export default function FooterSocialsSection({
	socialLinks,
}: IFooterSocialsSection) {
	return (
		<StyledFixedGridItem>
			<DigicertSiteSeal />
			<FooterSocialLinks {...socialLinks} />
		</StyledFixedGridItem>
	);
}

const StyledFixedGridItem = styled(FixedGridItem)`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content: space-between;
	gap: ${Css.pxToRemFromTheme(32)};
	margin-left: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		flex-direction: row-reverse;
		align-items: flex-start;
		width: fit-content;
	}
`;
